import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const HelpIcon = memo(({ fontSize, color = colors.basic.black, className }: SvgIconProps) => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" className={className} style={{ fontSize }}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.15973 5.91118C8.97583 5.24999 8.3674 4.84171 7.7488 4.92419L7.74474 4.92473L7.74474 4.92472C7.0421 5.01254 6.57558 5.57406 6.57558 6.21429C6.57558 6.49043 6.35172 6.71429 6.07558 6.71429C5.79943 6.71429 5.57558 6.49043 5.57558 6.21429C5.57558 5.06945 6.41763 4.08381 7.61868 3.93269C8.78024 3.77889 9.83282 4.5539 10.1301 5.66879C10.1328 5.67897 10.1352 5.68924 10.1373 5.69957C10.361 6.8182 9.76766 7.96489 8.68422 8.35183L8.67417 8.3553C8.53185 8.40274 8.42081 8.56092 8.42081 8.71429V9.30953C8.42081 9.58567 8.19696 9.80953 7.92081 9.80953C7.64467 9.80953 7.42081 9.58567 7.42081 9.30953V8.71429C7.42081 8.15536 7.78339 7.60121 8.35188 7.40865C8.92824 7.2005 9.28427 6.57112 9.15973 5.91118Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.38199 10.854C7.48929 10.7467 7.65664 10.6488 7.86136 10.6488C8.06607 10.6488 8.23342 10.7467 8.34072 10.854C8.44802 10.9613 8.54588 11.1286 8.54588 11.3333C8.54588 11.538 8.44802 11.7054 8.34072 11.8127C8.23342 11.92 8.06607 12.0179 7.86136 12.0179C7.65664 12.0179 7.48929 11.92 7.38199 11.8127C7.2747 11.7054 7.17683 11.538 7.17683 11.3333C7.17683 11.1286 7.2747 10.9613 7.38199 10.854Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.694656 8C0.694656 4.03338 3.8947 0.833332 7.86132 0.833332C11.8279 0.833332 15.028 4.03338 15.028 8C15.028 11.9666 11.8279 15.1667 7.86132 15.1667C3.8947 15.1667 0.694656 11.9666 0.694656 8ZM7.86132 1.83333C4.44699 1.83333 1.69466 4.58566 1.69466 8C1.69466 11.4143 4.44699 14.1667 7.86132 14.1667C11.2757 14.1667 14.028 11.4143 14.028 8C14.028 4.58566 11.2757 1.83333 7.86132 1.83333Z"
      fill={color}
    />
  </SvgIcon>
));
